import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

let nextId = 0

// Tells the native app while this <dialog> is open, so the Android back button
// closes the dialog instead of leaving the screen underneath it. Native replies
// to the "open" message to ask for the dialog to close.
export default class extends BridgeComponent {
  static component = "dismissible-dialog"

  initialize() {
    super.initialize()
    this.id = `dialog-${++nextId}`
  }

  connect() {
    super.connect()
    this.isOpen = false
    this.observer?.disconnect()
    this.observer = new MutationObserver(() => this.sync())
    this.observer.observe(this.element, { attributes: true, attributeFilter: ["open"] })
    this.sync()
  }

  disconnect() {
    this.observer?.disconnect()
    if (this.isOpen) this.send("close", { id: this.id })
    this.isOpen = false
    super.disconnect()
  }

  sync() {
    if (this.element.open === this.isOpen) return

    this.isOpen = this.element.open
    if (this.isOpen) {
      this.send("open", { id: this.id }, () => this.dismiss())
    } else {
      this.send("close", { id: this.id })
    }
  }

  // Closes the way Escape does, so the dialog's own cancel handling still runs.
  dismiss() {
    if (!this.element.open) return

    if (this.element.dispatchEvent(new Event("cancel", { cancelable: true }))) this.element.close()
  }
}
